import { useMutation } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

export type UseCheckPresetExistsParameters = {
    groupID: number,
    organizationID: number
} & BaseUseMutationParameters<boolean, { presetName: string }>;

export function useCheckPresetExists({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseCheckPresetExistsParameters) {

    return useMutation<boolean, RestError, { presetName: string }>(
        async (data) => {
            return await UICustomizationDataService.checkPresetExists(groupID, organizationID, data.presetName);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}